"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var SeriesStatus;
(function (SeriesStatus) {
    SeriesStatus[SeriesStatus["Pending"] = -3] = "Pending";
    SeriesStatus[SeriesStatus["Created"] = 0] = "Created";
    SeriesStatus[SeriesStatus["Transmitted"] = 1] = "Transmitted";
    SeriesStatus[SeriesStatus["Transmission_failure"] = 2] = "Transmission_failure";
    SeriesStatus[SeriesStatus["Processed"] = 3] = "Processed";
    SeriesStatus[SeriesStatus["Sent"] = 4] = "Sent";
    SeriesStatus[SeriesStatus["Delivered"] = 5] = "Delivered";
})(SeriesStatus = exports.SeriesStatus || (exports.SeriesStatus = {}));
exports.default = SeriesStatus;
